module.exports = require("npm:classlist-polyfill@1.2.0/src/index.js");